export default {
  title: "Accounting App"
};
